module.exports = __webpack_public_path__ + "static/media/acorn.1130d0d0.svg";